import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface UpdateIFRSExamDTO {
  title: string;
  chapterId: string;
  lectureId: string;
  duration: number;
  videoId?: string;
  modelAnswerUrl?: string;
}

export interface UpdateIFRSExamResponse {
  id: string;
  title: string;
  chapterId: string;
  lectureId: string;
  duration: string;
}

type UpdateIFRSExamAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: UpdateIFRSExamResponse;
};

export const UpdateIFRSExam = async (
  examId: string,
  data: UpdateIFRSExamDTO
): Promise<UpdateIFRSExamAPIResponse> => {
  try {
    const response = await axios.patch(`/ifrs/${examId}`, data);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

